import { render, staticRenderFns } from "./PatientCoachingSummaryWbi.vue?vue&type=template&id=3e50512d"
import script from "./PatientCoachingSummaryWbi.vue?vue&type=script&lang=js"
export * from "./PatientCoachingSummaryWbi.vue?vue&type=script&lang=js"
import style0 from "./PatientCoachingSummaryWbi.vue?vue&type=style&index=0&id=3e50512d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports